/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { IStillImageBgIntroViewConfig } from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { GameIntroView } from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import { EdisonGameModuleConfig } from "../EdisonGameModuleConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { EdisonParsedInitData } from "../server/data/EdisonParsedInitData";
import { EdisonGameMode } from "../gameMode/EdisonGameMode";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EdisonHelper } from "../../utils/EdisonHelper";
import { TimelineLite } from "gsap";
import { EdisonParsedGameData } from "../server/data/EdisonParsedGameData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

export class EdisonIntroView extends GameIntroView {

    private _gfxContainer:PIXI.Container;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _restore:boolean = false;
    private _backgroundSpineAnim:PIXI.spine.Spine;
    private _featureSpineAnim:PIXI.spine.Spine;
    private _aspectRatio:number = 1;
    private _spineSprite:PIXI.Sprite;
    private _bgLayer:ScalableLayer;

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._restore = data.isRestoreState && data.mode === EdisonGameMode.FREESPIN && data.nextMode === EdisonGameMode.FREESPIN;
    }


    protected initAnimations():void {
        super.initAnimations();
        this._spineSprite.anchor.set(0.5, 0.5);
        this._spineSprite.x = 630;
        this._spineSprite.y = 280;
        this._bgLayer.addChild(this._spineSprite);
    }


    protected createGameGraphics():PIXI.DisplayObject {
        this._bgLayer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.INTRO_BG.name);
        this._gfxContainer = new PIXI.Container();
        this._spineSprite = new PIXI.Sprite();

        this._backgroundSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("backgroundSpine"));
        this._spineSprite.addChild(this._backgroundSpineAnim);
        //this._gfxContainer.addChild(this._spineSprite);

        this._featureSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("introFeatPres"));
        this._gfxContainer.addChild(this._featureSpineAnim);
        this._featureSpineAnim.visible = false;

        return this._gfxContainer;
    }

    private updateBackgroundImage(resizeData:IResizeData):void {

        const screenWidth = resizeData.width / this._layer.scale.x;
        const screenHeight = resizeData.height / this._layer.scale.y;
        const bgScreenWidth = resizeData.width / this._bgLayer.scale.x;

        this._aspectRatio = screenWidth / screenHeight;

        const xRatio:number = this._orientation === Orientation.LANDSCAPE ? this._aspectRatio > 1.4 ? this._aspectRatio < 2 ? 1 : 1.25 : 1 :
            this._aspectRatio > .5 ? 1.5 / this._aspectRatio : 1 / this._aspectRatio;
        const yRatio:number = this._orientation === Orientation.LANDSCAPE ? this._aspectRatio > 1.4 ? this._aspectRatio < 2 ? 1 : 1 : 1 :
            1 / this._aspectRatio;

       // this._spineSprite.width = EdisonGameConfig.instance.GAME_WIDTH;
        //this._spineSprite.height = EdisonGameConfig.instance.GAME_HEIGHT;
        //this._spineSprite.scale.set(xRatio, yRatio);

        this._featureSpineAnim.visible = true;
        this._featureSpineAnim.position.set(screenWidth / 2, screenHeight / 2);

        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._backgroundSpineAnim.state.setAnimation(0, "IntroLandscape", true);
            this._spineSprite.x = 630; //screenWidth / 2;
            this._spineSprite.y = 280;
            this._spineSprite.anchor.set(0.5, 0.5);
            this._spineSprite.scale.set(0.7, 0.7);

            this._featureSpineAnim.scale.set(1);
            this._featureSpineAnim.state.setAnimation(0, "IntroFeaturePresentationLandscape", true);
        } else {
            this._backgroundSpineAnim.state.setAnimation(0, "IntroPortrait", true);
            this._spineSprite.y = 630;
            this._spineSprite.y = 340;
            this._spineSprite.anchor.set(0.5, 0.5);
            this._spineSprite.scale.set(1.4, 1.4);

            this._featureSpineAnim.scale.set(1);
            this._featureSpineAnim.state.setAnimation(0, "IntroFeaturePresentation", true);
        }
        this._featureSpineAnim.position.set(screenWidth / 2, screenHeight / 2.5);


    }

    protected onResizeBackground(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;

        this.updateBackgroundImage(resizeData);
    }

    protected startPresentation(data?:EdisonParsedGameData, onShowComplete?:() => void):void {
        super.startPresentation(data, onShowComplete);
    }

    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(closeCallback);

        this._bgLayer.removeChild(this._spineSprite);

        if(this._restore) {
            let tl:TimelineLite = new TimelineLite();
            tl.add(() => {
                EdisonGameModuleConfig.freespinOverlay.playInitMetersAnimations(true);
            }, 0);
        }

        for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
            EdisonHelper.sortSymbolLayerLevels(i);
        }
    }

}